import React from 'react';

const Subscriptions = () => <div>Subscriptions</div>;

export default Subscriptions;
